import React from 'react';

import { DesktopAlert } from 'admin/notifications/Notifications.types';

export interface DesktopAlertComponentProps {
    alert: DesktopAlert;
    onClose: () => void;
}

type AlertComponentLoader = () => Promise<{
    default: React.ComponentType<DesktopAlertComponentProps>;
}>;

export interface DesktopAlertRegistration {
    /** Lazy loader for the team-owned component. The component renders its own modal shell. */
    loader: AlertComponentLoader;

    /** Translation key for the action button label on the desktop alert card */
    actionLabelKey?: string;

    /** Icon class for the desktop alert card */
    icon?: string;
}

const registry: Record<string, DesktopAlertRegistration> = {};

/**
 * Registers a desktop alert type with the CORE alert system.
 */
export const registerDesktopAlert = (eventType: string, registration: DesktopAlertRegistration): void => {
    registry[eventType] = registration;
};

export const getDesktopAlertLoader = (eventType: string): AlertComponentLoader | undefined => {
    return registry[eventType]?.loader;
};

export const getActionLabelKey = (eventType: string): string | undefined => {
    return registry[eventType]?.actionLabelKey;
};

export const getAlertIcon = (eventType: string): string | undefined => {
    return registry[eventType]?.icon;
};

export const getRegisteredEventTypes = (): string[] => {
    return Object.keys(registry);
};
